var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('OtpVerification',{on:{"skip":function($event){return _vm.skipEventHandler()},"resend":function($event){return _vm.resendEventHandler()},"continue":_vm.continueEventHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }